/**
 * 方法库 **/
import Big from 'big.js'
export default {
  // 获取url中的特定query
  getUrlQuery(key) {
    const url = window.location.href
    const queryStr = url.includes('?') ? url.split('?')[1] : ''
    if (queryStr) {
      const variables = queryStr.split('&')
      const len = variables.length
      for (let i = 0; i < len; i++) {
        const item = variables[i].split('=')
        if (item[0] === key) {
          return item[1]
        }
      }
    } else {
      return ''
    }
  },
  // 删除对象的某些key值，keys为数组
  removeKeys(object, keys = []) {
    return Object.keys(object).reduce((acc, current) => {
      if (keys.some((k) => k === current)) {
        return acc
      }
      return { ...acc, [`${current}`]: object[current] }
    }, {})
  },
  // 弧度转角度
  rad2deg(rad) {
    if (rad || rad === 0) {
      const deg = (180 / Math.PI * Number(rad)).toFixed(2)
      return Number(deg)
    }
  },

  // 四舍五入保留六位小数
  formatDecimal(value, number = 6) {
    if (value) {
      if (typeof value === 'number') {
        value = value.toString()
      }
      const values = value.split('.')
      if (values.length > 1 && values[1].length > 6) {
        return Number(value).toFixed(number)
      }
    }
    return value
  },

  // revit插件比较版本
  /** -1小于      1大于    0等于或者不符合规定的版本号  */
  compareVersion(v1, v2 = '3.6.8.36') {
    if (/^\d+\.\d+\.\d+\.\d+$/g.test(v1) && /^\d+\.\d+\.\d+\.\d+$/g.test(v2)) {
      let cpResult = 0
      const arr1 = v1.split('.')
      const arr2 = v2.split('.')
      for (let i = 0; i < arr1.length; i++) {
        const s1 = arr1[i]
        const s2 = arr2[i]
        if (s1 !== s2) {
          cpResult = s1 - s2
          break
        }
      }
      return cpResult > 0 ? 1 : cpResult === 0 ? 0 : -1
    } else {
      return -1
    }
  },
  // 递归去除children为空的数组
  getTreeData(data) {
    // 循环遍历json数据
    for (let i = 0; i < data.length; i++) {
      if (data[i].children.length < 1) {
        // children若为空数组，则将children设为undefined
        data[i].children = undefined
        data[i].isLeaf = true
      } else {
        // children若不为空数组，则继续 递归调用 本方法
        this.getTreeData(data[i].children)
      }
    }
    return data
  },
  /** -------------------对象或数组深拷贝---------------------------**/
  deepCopy(source) {
    const sourceCopy = source instanceof Array ? [] : {}
    for (const item in source) {
      sourceCopy[item] = typeof source[item] === 'object' && source[item] !== null
        ? this.deepCopy(source[item]) : source[item]
    }
    return sourceCopy
  },
  /** ------------------- 按 key 排序 ---------------------------**/
  compare(property) {
    return function(obj1, obj2) {
      const value1 = obj1[property]
      const value2 = obj2[property]
      if (value1 < value2) { return -1 }
      if (value1 > value2) { return 1 }
      return 0
    }
  },

  /** ------------- 将树形data中重复的id/code变成id+parentId/code+parentCode,确保树形data的节点唯一性 -------------**/
  uniqueTreeList(arr, key = 'id', createUniqueKeyName = 'uniqueId') {
    const list = this.deepCopy(arr).sort((c1, c2) => c1.weight - c2.weight)
    const parentNodeKey = key === 'code' ? 'parentCode' : 'parentId'
    const ids = []
    list.forEach((item) => {
      // 有重复，就生成新的值; 没有重复的就使用本身的id
      const isRepeated = ids.includes(item[key])
      item[createUniqueKeyName] = isRepeated ? `${item[key]}_${item[parentNodeKey]}` : item[key]
      if (!isRepeated) {
        ids.push(item[key])
      }
    })
    return list
  },

  /** ------------------- 将扁平数组转为树形结构 ---------------------------**/
  listToTree(arr, key = 'code', rootParentCode) {
    const list = this.deepCopy(arr).sort((c1, c2) => c1.weight - c2.weight)
    const parentNodeKey = key === 'code' ? 'parentCode' : 'parentId'
    const map = {}; let node; const tree = []; let i
    for (i = 0; i < list.length; i++) {
      map[list[i][key]] = list[i]
      list[i].children = []
    }
    for (i = 0; i < list.length; i += 1) {
      node = list[i]
      if ((node[parentNodeKey] || node[parentNodeKey] === 0) && node[parentNodeKey] !== rootParentCode) {
        if (map[node[parentNodeKey]]) {
          map[node[parentNodeKey]].children.push(node)
        }
      } else {
        tree.push(node)
      }
    }
    return this.getTreeData(tree)
  },

  /** ------------------- 根据children code 寻找父级链路 ---------------------------**/
  getPathByChildCode(source, childCode, rootCode, codes = [], names = []) {
    const child = source.find((x) => x.code === childCode)
    if (!child) {
      return { codes: [], names: [] }
    }
    codes.unshift(child.code)
    names.unshift(child.name)
    if (child.parentCode && child.parentCode !== rootCode) { // 根节点不用显示
      const parent = source.find((p) => p.code === child.parentCode)
      return this.getPathByChildCode(source, parent.code, rootCode, codes, names)
    }
    return { codes, names }
  },

  /** ------------------- 根据children code 寻找父级链路 ---------------------------**/
  // 根据children id 寻找父级链路
  getPathByChild(source, childId, rootId, ids = [], names = []) {
    const child = source.find((x) => { return x.id === childId })
    if (!child) {
      return { ids: [], names: [] }
    }
    ids.unshift(child.id)
    names.unshift(child.name)

    if (child.parentId && child.parentId !== rootId) { // 根节点不用显示
      const parent = source.find((p) => { return p.id === child.parentId })
      return this.getPathByChild(source, parent.id, rootId, ids, names)
    }
    return { ids, names }
  },

  /** ------------------- 计算文字长度 ---------------------------**/
  calcTextWidth(text, font = 'bold 1rem Helvetica') {
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')
    context.font = font
    const textLength = text.length
    const targetLength = textLength > 4 ? Math.ceil(textLength / 2) : 4
    const targetText = text.slice(0, targetLength)
    const { width } = context.measureText(targetText)
    return Number(width.toFixed(0))
  },

  /** ------------------- 引入big.js的乘法-解决精度问题 ---------------------------**/
  timesValue(rate, times, digit) {
    return rate || rate === 0 ? Number(Big(rate).times(times).toFixed(digit)) : null
  },
  /** ------------------- 加密 ---------------------------**/
  encrypt(s) {
    return s
      .split('')
      .map((c) => {
        const code = c.charCodeAt(0)
        return code >= 65 && code <= 90
          ? String.fromCharCode(code + 32)
          : code >= 97 && code <= 122
            ? String.fromCharCode(code - 32)
            : c
      })
      .join('')
  },

  /** ------------------- 比较版本大小,targetVersion是否比sourceVersion版本高 ---------------------------**/
  isHigherVersion(targetVersion, sourceVersion) {
    const targetArr = targetVersion ? targetVersion.split('.') : []
    const sourceArr = sourceVersion ? sourceVersion.split('.') : []
    const flag = false
    for (let i = 0; i < targetArr.length; i++) {
      if ((sourceArr[i] || sourceArr[i] === 0) && targetArr[i] - sourceArr[i] > 0) {
        return true
      }
    }
    return flag
  },
}
